
import React from 'react';
import './App.css';
import { Switch, Route, Redirect } from 'react-router-dom';
import ProjectCreatePage from './pages/ProjectCreatePage';
import EntityCreatePage from './pages/EntityCreatePage';
import ComplexTypeEdit from './pages/ComplexTypeEdit';
import ProjectPage from './pages/ProjectPage';
import HomePage from './IVySoft.SiteBuilder.Web/HomePage/HomePage';
import EmailConfirmPage from './IVySoft.SiteBuilder.Users.Web/EmailConfirmPage';
import LoginPage from './IVySoft.SiteBuilder.Users.Web/LoginPage';
import ProjectImport from './pages/ProjectImport';
import ProjectsPage from './pages/ProjectsPage';
import CreateStaticPage from './IVySoft.SiteBuilder.StaticPages.Web/CreateStaticPage';
import ViewStaticPage from './IVySoft.SiteBuilder.StaticPages.Web/ViewStaticPage';
import EditStaticPage from './IVySoft.SiteBuilder.StaticPages.Web/EditStaticPage';
import ProductsPage from './IVySoft.SiteBuilder.Products.Web/ProductsPage';
import ProductPageEdit from './IVySoft.SiteBuilder.Products.Web/ProductPageEdit';
import ProductPageViewPage from './IVySoft.SiteBuilder.Products.Web/ProductPageViewPage';
import ProductPagesPage from './IVySoft.SiteBuilder.Products.Web/ProductViewPage';
import ProductCreatePage from './IVySoft.SiteBuilder.Products.Web/ProductCreatePage';
import ProductPageCreatePage from './IVySoft.SiteBuilder.Products.Web/ProductPageCreatePage';

function App() {
  return (
    <Switch>
      <Route exact path="/" component={HomePage} />

      <Route exact path="/user/confirm/:token_id?" component={EmailConfirmPage} />
      <Route exact path="/user/login" component={LoginPage} />

      <Route exact path="/products/create" component={ProductCreatePage} />
      <Route exact path="/products" component={ProductsPage} />
      <Route exact path="/product/:product_name" component={ProductPagesPage} />
      <Route exact path="/product/:product_name/create_page" component={ProductPageCreatePage} />
      <Route exact path="/product/:product_name/:page_name/edit" component={ProductPageEdit} />
      <Route exact path="/product/:product_name/:page_name" component={ProductPageViewPage} />

      <Route exact path="/pages/:product/create" component={CreateStaticPage} />
      <Route exact path="/page/:product/:id" component={ViewStaticPage} />
      <Route exact path="/page/:product/:id/edit" component={EditStaticPage} />

      <Route exact path="/projects" component={ProjectsPage} />
      <Route exact path="/projects/create" component={ProjectCreatePage} />
      <Route exact path="/projects/import" component={ProjectImport} />
      <Route exact path="/project/:project_id/entity/create/" component={EntityCreatePage} />
      <Route exact path="/project/:module_id/complex_type/:id/edit" component={ComplexTypeEdit} />
      <Route exact path="/project/:id" component={ProjectPage} />
      <Redirect to='/' />
    </Switch>
    );
}

export default App;
